import { render, staticRenderFns } from "./threshold.vue?vue&type=template&id=4ccb780a&scoped=true&"
import script from "./threshold.vue?vue&type=script&lang=js&"
export * from "./threshold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccb780a",
  null
  
)

export default component.exports